import { Route, BrowserRouter as Router, Routes } from "react-router";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import Blank from "./pages/Blank";
import Calendar from "./pages/Calendar";
import Ecommerce from "./pages/Dashboard/ECommerce";
import FormElements from "./pages/Forms/FormElements";
import NotFound from "./pages/OtherPage/NotFound";
import BasicTables from "./pages/Tables/BasicTables";
import Alerts from "./pages/UiElements/Alerts";
import Avatars from "./pages/UiElements/Avatars";
import Badges from "./pages/UiElements/Badges";
import Buttons from "./pages/UiElements/Buttons";
import Images from "./pages/UiElements/Images";
import Videos from "./pages/UiElements/Videos";
import UserProfiles from "./pages/UserProfiles";
import ExamsList from "./pages/Exams/ExamsList";
import CreateExam from "./pages/Exams/CreateExam";
import ImportExam from "./pages/Exams/ImportExam";
import { Provider } from "react-redux";
import { store } from "./store/store";
import UserList from "./pages/Users/UserList";
import UserCreate from "./pages/Users/UserCreate";
import AddUser from "./pages/Users/AddUser";
import EditUser from "./pages/Users/EditUser";
import CategoriesList from "./pages/Categories/CategoriesList";
import SliderList from "./pages/Slider/SliderList";
import CreateSlider from "./pages/Slider/CreateSlider";
import CreateCourse from "./pages/Course/CreateCourse";
import CourseList from "./pages/Course/CourseList";
import LessonList from "./pages/Lesson/LessonList";
import LessonCreatePage from "./pages/Lesson/CreateLesson";
import EditSlider from "./pages/Slider/EditSlider";
import EditCourse from "./pages/Course/EditCourse";
import FeedbackList from "./pages/Media/Feedback/FeedbackList";
import EditFeedback from "./pages/Media/Feedback/EditFeedback";
import CreateFeedback from "./pages/Media/Feedback/CreateFeedback";
import PartnersList from "./pages/Media/Partners/PartnersList";
import EditPartners from "./pages/Media/Partners/EditPartners";
import CreatePartners from "./pages/Media/Partners/CreatePartners";
import SocialsList from "./pages/Media/Socials/SocialsList";
import EditSocials from "./pages/Media/Socials/EditSocials";
import CreateSocials from "./pages/Media/Socials/CreateSocials";
import HighlightList from "./pages/Media/Highlight/HighlightList";
import EditHighlight from "./pages/Media/Highlight/EditHighlight";
import CreateHighlight from "./pages/Media/Highlight/CreateHighlight";
import Setting from "./pages/Setting/Setting";
import PostList from "./pages/Post/PostList";
import CreatePost from "./pages/Post/CreatePost";
import EditPost from "./pages/Post/EditPost";
import AboutList from "./pages/About/AboutList";
import EditAbout from "./pages/About/EditAbout";
import CreateAbout from "./pages/About/CreateAbout";
import EditProfile from "./pages/Profile/EditProfile";
import OrderList from "./pages/Order/OrderList";
import EditOrder from "./pages/Order/EditOrder";
import QuizAttempts from "./pages/QuizAttempt/QuizAttempts";
import QuizAttempt from "./pages/QuizAttempt/QuizAttempt";
import ExamOverviewList from "./pages/ExamOverview/ExamOverviewList";
import ExamOverviewEdit from "./pages/ExamOverview/ExamOverviewEdit";
import ExamOverviewCreate from "./pages/ExamOverview/ExamOverviewCreate";
import TeammateList from "./pages/Teammate/TeammateList";
import TeammateEdit from "./pages/Teammate/TeammateEdit";
import TeammateCreate from "./pages/Teammate/TeammateCreate";
import OnlineCLassList from "./pages/OnlineClass/OnlineCLassList";
import OnlineCLassEdit from "./pages/OnlineClass/OnlineCLassEdit";
import OnlineClassCreate from "./pages/OnlineClass/OnlineClassCreate";
import LearningList from "./pages/LearningByTraveling/LearningList";
import LearningEdit from "./pages/LearningByTraveling/LearningEdit";
import LearningCreate from "./pages/LearningByTraveling/LearningCreate";
import DynamicBlocks from "./pages/DynamicBlocks/DynamicBlocks";
import CreateDynamicBlock from "./pages/DynamicBlocks/CreateDynamicBlock";
import EditDynamicBlock from "./pages/DynamicBlocks/EditDynamicBlock";

export default function App() {

  return (
    <>
      <Router>
        <Routes>
          {/* Dashboard Layout */}
          <Route element={<AppLayout />}>
            <Route index path="/" element={<Ecommerce />} />
            {/* Others Page */}
            <Route path="/profile" element={<UserProfiles />} />
            <Route path="/profile/update" element={<EditProfile />} />

            <Route path="/calendar" element={<Calendar />} />
            <Route path="/blank" element={<Blank />} />

            {/* Orders */}
            <Route path="/orders" element={<OrderList />} />
            <Route path="/order/:id/update" element={<EditOrder />} />

            {/* Categories */}
            <Route path="/categories" element={<CategoriesList />} />

            {/* Dynamic Blocks */}
            <Route path="/dynamic-blocks" element={<DynamicBlocks />} />
            <Route path="/dynamic-blocks/create" element={<CreateDynamicBlock />} />
            <Route path="/dynamic-blocks/edit/:id" element={<EditDynamicBlock />} />

            {/* Slider */}
            <Route path="/slider" element={<SliderList />} />
            <Route path="/slider/:id/update" element={<EditSlider />} />
            <Route path="/slider/create" element={<CreateSlider />} />

            {/* Feedback */}
            <Route path="/feedback" element={<FeedbackList />} />
            <Route path="/feedback/:id/update" element={<EditFeedback />} />
            <Route path="/feedback/create" element={<CreateFeedback />} />

            {/* Partner */}
            <Route path="/partners" element={<PartnersList />} />
            <Route path="/partner/:id/update" element={<EditPartners />} />
            <Route path="/partner/create" element={<CreatePartners />} />

            {/* Socials */}
            <Route path="/socials" element={<SocialsList />} />
            <Route path="/social/:id/update" element={<EditSocials />} />
            <Route path="/social/create" element={<CreateSocials />} />

            {/* Highlight */}
            <Route path="/highlight" element={<HighlightList />} />
            <Route path="/highlight/:id/update" element={<EditHighlight />} />
            <Route path="/highlight/create" element={<CreateHighlight />} />

            {/* Courses */}
            <Route path="/courses" element={<CourseList />} />
            <Route path="/course/:id/update" element={<EditCourse />} />
            <Route path="/create-course" element={<CreateCourse />} />

            {/* Lesson */}
            <Route path="/course/:courseId/lesson" element={<LessonList />} />
            <Route path="/course/:courseId/lesson/create" element={<LessonCreatePage />} />

            {/* Blog */}
            <Route path="/blog" element={<PostList />} />
            <Route path="/blog/:id/update" element={<EditPost />} />
            <Route path="/create-blog" element={<CreatePost />} />

            <Route path="/abouts" element={<AboutList />} />
            <Route path="/abouts/:id/update" element={<EditAbout />} />
            <Route path="/create-abouts" element={<CreateAbout />} />

            {/* Exam Overview */}
            <Route path="/exam-overview" element={<ExamOverviewList />} />
            <Route path="/exam-overview/:id/update" element={<ExamOverviewEdit />} />
            <Route path="/create-exam-overview" element={<ExamOverviewCreate />} />

            {/* Teammate */}
            <Route path="/teammate" element={<TeammateList />} />
            <Route path="/teammate/:id/update" element={<TeammateEdit />} />
            <Route path="/create-teammate" element={<TeammateCreate />} />

            {/* Online Class */}
            <Route path="/online-class" element={<OnlineCLassList />} />
            <Route path="/online-class/:id/update" element={<OnlineCLassEdit />} />
            <Route path="/create-online-class" element={<OnlineClassCreate />} />

            {/* Online Class */}
            <Route path="/learning" element={<LearningList />} />
            <Route path="/learning/:id/update" element={<LearningEdit />} />
            <Route path="/create-learning" element={<LearningCreate />} />

            {/* Exams */}
            <Route path="/exams" element={<ExamsList />} />
            <Route path="/exams/:examId/update" element={<CreateExam />} />
            <Route path="/exams/import" element={<ImportExam />} />

            <Route path="/quiz/attempts" element={<QuizAttempts />} />
            <Route path="/quiz/attempt/:id/detail" element={<QuizAttempt />} />

            <Route path="/form-elements" element={<FormElements />} />

            {/* User */}
            <Route path="/users" element={<UserList />} />
            <Route path="/user/:id" element={<UserCreate />} />
            <Route path="/edit-user/:id" element={<EditUser />} />
            <Route path="/user/add" element={<AddUser />} />

            <Route path="/setting" element={<Setting />} />

            {/* Tables */}
            {/* <Route path="/basic-tables" element={<BasicTables />} /> */}

            {/* Ui Elements */}
            {/* <Route path="/alerts" element={<Alerts />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/badges" element={<Badges />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/images" element={<Images />} />
            <Route path="/videos" element={<Videos />} /> */}
          </Route>

          {/* Auth Layout */}
          <Route element={<AuthLayout />}>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
          </Route>

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}
